import { useState } from 'react';
import { useIntersection } from 'react-use';

export const useHasEnteredViewport = (element: any, rootMargin: any) => {
    const [hasEnteredViewport, setHasEnteredViewport] = useState(false);

    const intersection = useIntersection(element, {
        rootMargin,
    });

    if (intersection?.isIntersecting && !hasEnteredViewport) {
        setHasEnteredViewport(true);
    }

    return hasEnteredViewport;
};
